/* eslint-disable consistent-return */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withNamespaces } from 'react-i18next';
import PropTypes from 'prop-types';
import ListItem from '../BaseModuleListItem';
import {
  changeBaseModuleScreen,
  changeBaseModuleLang,
  setCurrentModule,
} from '../../../actions/baseModule';
import { getFilteredModuleList } from '../../../selectors';
import { baseModuleScreens } from '../../../constants';
import BaseModuleLangSelect from '../BaseModuleLangSelect';
import i18n from '../../../internationalization/i18n';


const propTypes = {
  changeBaseModuleScreen: PropTypes.func.isRequired,
  setCurrentModule: PropTypes.func.isRequired,
  lang: PropTypes.string.isRequired,
  langs: PropTypes.array.isRequired,
  moduleList: PropTypes.array.isRequired,
  changeBaseModuleLang: PropTypes.func.isRequired,
};

const defaultProps = {
};

const renderModulesList = (modulesList, handleOpenItemList) => (
  modulesList.map(entity => (
    <ListItem
      canOpen
      key={entity.id}
      module={entity}
      openItemList={handleOpenItemList}
    />
  ))
);

class BaseModuleOverview extends Component {
  constructor(props) {
    super(props);
    this.handleOpenItemList = this.handleOpenItemList.bind(this);
    this.changeLang = this.changeLang.bind(this);
  }

  changeLang(lang) {
    this.props.changeBaseModuleLang(lang);
  }

  handleOpenItemList(moduleId) {
    const currentModule = this.props.moduleList.find(module => module.id === moduleId);
    if (!currentModule) {
      return null;
    }
    this.props.changeBaseModuleScreen(baseModuleScreens.moduleItemsList);
    this.props.setCurrentModule(currentModule);
  }

  render() {
    const { moduleList } = this.props;
    return (
      <div className="c-bb-basemodule">
        <div className="c-bb-basemodule-header">
          <div className="c-bb-basemodule-header-icon">
            <i className="icon-password" />
          </div>
          <h1 className="c-bb-basemodule-header-title">
            {i18n.t('CONTENT.baseModuleItems')}
          </h1>
          <BaseModuleLangSelect
            currentLang={this.props.lang}
            onSelect={this.changeLang}
            langs={this.props.langs}
          />
        </div>
        <div className="c-bb-basemodule-list">
          { renderModulesList(moduleList, this.handleOpenItemList) }
        </div>
      </div>
    );
  }
}

BaseModuleOverview.propTypes = propTypes;
BaseModuleOverview.defaultProps = defaultProps;

const mapStateToProps = state => ({
  lang: state.baseModule.lang,
  langs: state.baseModule.langs,
  moduleList: getFilteredModuleList(state),
});

const mapDispatchToProps = {
  changeBaseModuleScreen,
  changeBaseModuleLang,
  setCurrentModule,
};

export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(BaseModuleOverview));



// WEBPACK FOOTER //
// ./src/components/BaseModule/BaseModuleItems/BaseModuleItemsOverview.js